import type { FC } from 'react';
import { SimpleGrid, Skeleton } from '@chakra-ui/react';
import { BloomreachProductType } from '../../hooks/use-search/use-search-types';
import { RecipeCategoryHeaderSkeleton } from '../recipe-category-header/RecipeCategoryHeaderSkeleton';
import { BreadcrumbSkeleton } from './BreadcrumbSkeleton';
import { FilterButtonsSkeleton } from './FilterButtonsSkeleton';
import { RecipeTileSkeleton } from './RecipeTileSkeleton';

const skeletonItems = Array.from({ length: 12 }, (_, index) => `skeleton-${index}`);

interface SearchSkeletonsProps {
    productType?: BloomreachProductType;
}

export const SearchSkeletons: FC<SearchSkeletonsProps> = ({ productType }) => (
    <div
        className="mx-auto h-full w-full max-w-[1928px] overflow-x-hidden"
        data-testid="search-skeleton"
    >
        <div className="flex flex-col gap-4 px-0 sm:px-8 sm:py-4 lg:px-10 xl:px-16">
            {/* Breadcrumb skeleton */}
            <BreadcrumbSkeleton />

            <div className="flex flex-col gap-6" data-testid="category-search-slot-header">
                <div className="flex flex-col gap-4">
                    {/* Recipe category header skeleton for recipes */}
                    {productType === BloomreachProductType.recipe ? (
                        <RecipeCategoryHeaderSkeleton />
                    ) : (
                        /* Header skeleton for hardgood products */
                        <div className="flex items-center justify-between px-4 sm:px-0">
                            <Skeleton height="32px" width="300px" borderRadius="0" />
                            <Skeleton height="20px" width="80px" borderRadius="0" />
                        </div>
                    )}

                    {/* FilterButtons skeleton */}
                    <FilterButtonsSkeleton productType={productType} />

                    {/* SearchListing skeleton */}
                    <SimpleGrid
                        columns={{ base: 2, sm: 3, md: 4 }}
                        columnGap={{ base: 3, sm: 6 }}
                        rowGap={8}
                        alignItems="stretch"
                    >
                        {skeletonItems.map((id) =>
                            productType === BloomreachProductType.recipe ? (
                                <RecipeTileSkeleton key={id} />
                            ) : (
                                <Skeleton
                                    key={id}
                                    height={{
                                        base: '392px',
                                        sm: '427px',
                                        md: '456px',
                                        lg: '573px',
                                        xl: '612px',
                                    }}
                                />
                            ),
                        )}
                    </SimpleGrid>
                    <div className="mt-8 flex w-full flex-col items-center justify-center gap-3">
                        <Skeleton height="24px" width="134px" borderRadius="0" />
                        <Skeleton height="40px" width="174px" borderRadius="0" />
                    </div>
                </div>
            </div>
        </div>
    </div>
);
